export { registerComponent as registerCountdownComponent } from '../../components/builtin/Countdown/register'
export { default as Countdown } from '../../components/builtin/Countdown/Countdown'
